import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScrollTopComponent } from '../components/scroll-top/scroll-top.component';
import { IosLocationTutorialComponent } from '../components/ios-location-tutorial/ios-location-tutorial.component';

import { PoptionalsComponent } from '../components/poptionals/poptionals.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule
     ],
    declarations: [
        ScrollTopComponent,
    	IosLocationTutorialComponent,
        PoptionalsComponent
    ],
    exports: [
        ScrollTopComponent,
    	IosLocationTutorialComponent,
        PoptionalsComponent
    ]
})
export class SharedModule {}
